import Autocomplete from '../components/autocomplete';
import { getWebsiteIdFromPath } from '../util/websiteIdExtractor';

class VehicleSearch {
    bind() {
        for (const vehicleSearch of document.querySelectorAll('[data-stock-vehicle-search-form]')) {
            if (vehicleSearch === null || vehicleSearch.dataset.bound) {
                return;
            }

            const searchField = vehicleSearch.querySelector('[data-stock-vehicle-search-field]');
            const idField = vehicleSearch.querySelector('[data-stock-vehicle-id]');
            const autocomplete = new Autocomplete();
            const autoCompleteSuggestionArea = autocomplete.createContainer();
            vehicleSearch.appendChild(autoCompleteSuggestionArea);

            function createSuggestion(data) {
                const suggestion = autocomplete.createElement();

                suggestion.innerHTML = `<div class="flex flex-col">
    <div>${data.displayName}</div>`;

                suggestion.innerHTML += '</div>';

                suggestion.addEventListener('click', () => {
                    idField.value = data.vehicleId;
                    searchField.value = data.displayName;
                    autoCompleteSuggestionArea.hidden = true;
                });

                return suggestion;
            }

            function updateSuggestions() {
                fetch(`/${getWebsiteIdFromPath()}/stock/vehicle/search?q=${searchField.value}`)
                    .then((response) => response.json())
                    .then((json) => {
                        autoCompleteSuggestionArea.innerText = '';

                        if (json.error !== undefined) {
                            return;
                        }

                        for (const suggestion of json) {
                            autoCompleteSuggestionArea.appendChild(createSuggestion(suggestion));
                            autoCompleteSuggestionArea.hidden = false;
                        }
                    });
            }

            function bindField(field) {
                field.addEventListener('input', () => {
                    if (field.value.length < 2) {
                        autoCompleteSuggestionArea.hidden = true;
                        return;
                    }

                    updateSuggestions();
                });
            }

            bindField(searchField);

            vehicleSearch.dataset.bound = 'true';
        }
    }
}

const vehicleSearch = new VehicleSearch();
vehicleSearch.bind();

document.addEventListener('click', () => {
    vehicleSearch.bind();
});
